const UserRoleEnum = {
    COORDINATOR: 2,
    BOARD: 3,
    ADMIN: 4,
    MENTOR: 5,
    FINANCE: 6,
    SYSTEM_ADMIN: 7,
    SOLIDARITY_FUND: 8,
    SOCIAL_MEDIA: 9,

  };

  export const UserRoleFriendlyNames = {
    [UserRoleEnum.COORDINATOR]: "Os. Koordynatorska",
    [UserRoleEnum.BOARD]: "Zarząd",
    [UserRoleEnum.ADMIN]: "Admin",
    [UserRoleEnum.MENTOR]: "Os. Mentorska",
    [UserRoleEnum.FINANCE]: "Os. Finansowa",
    [UserRoleEnum.SOLIDARITY_FUND]: "Fundusz Solidarnościowy",
    [UserRoleEnum.SYSTEM_ADMIN]: "Admin Systemowy",
    [UserRoleEnum.SOCIAL_MEDIA]: "Media społ."
  };
  
  export default UserRoleEnum;